.root {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
}

.canvas {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  touch-action: none;
}

.tooltip {
  position: absolute;
  pointer-events: none;
  background: var(--chartv2-tooltip-background, rgba(20, 22, 26, 92%));
  color: var(--chartv2-tooltip-foreground, var(--text-default, #e6e7ea));
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid
    var(--chartv2-axis-line, var(--border-soft, rgba(255, 255, 255, 12%)));
  font-size: 12px;
  line-height: 1.4;
  min-width: 140px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 35%);
  transform: translate(12px, 12px);
  z-index: 2;
}

.tooltipTime {
  font-weight: 600;
  margin-bottom: 4px;
  opacity: 0.9;
}

.tooltipRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.tooltipSwatch {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 6px;
}

.tooltipLabel {
  display: flex;
  align-items: center;
}

.tooltipValue {
  font-variant-numeric: tabular-nums;
}

.empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  font-size: 13px;
  pointer-events: none;
}
